<cm-material-node-io [nodeId]="$nodeId()" [material]="$material()" [socket]="$socket()"> </cm-material-node-io>
